import { config } from '../config';

export const encodeQueryData = (attributeMap: connect.AttributeDictionary) => {
  const data: any = {
    first_name: attributeMap.FirstName?.value,
    last_name: attributeMap.LastName?.value,
    phone: attributeMap.Phone?.value,
    email: attributeMap.Email?.value,
    gclid: attributeMap.gclid?.value,
  };
  const params = [];
  for (let key in data) {
    if (data[key]) {
      params.push(encodeURI(key) + '=' + encodeURI(data[key]));
    }
  }
  if (params.length) {
    return `${config.platformUrl}/order_create?${params.join('&')}`;
  }
  return `${config.platformUrl}/order_create`;
};
